import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TextLink } from '../../../../components/ui';
import { tipoTermoUsoEnum } from '../../../../shared/util/enums/tipoTermoUsoEnum';
import styles from './FooterQuickLinks.module.css';

export default function FooterQuickLinks({ openTermsOfUse, openPrivacy }) {
  const { t } = useTranslation('footer');
  return (
    <div className={styles.root}>
      <div className={styles.title}>{t('FAST_ACCESS')}</div>
      <div>
        <TextLink as={Link} to='/' className={styles.link}>
          {t('HOME')}
        </TextLink>
      </div>
      <div>
        <TextLink onClick={openPrivacy} className={styles.link}>
          {t('PRIVACY_POLICY')}
        </TextLink>
      </div>
      <div>
        <TextLink
          onClick={e => openTermsOfUse(e, tipoTermoUsoEnum.USUARIO)}
          className={styles.link}>
          {t('CUSTOMER_TERMS_OF_USE')}
        </TextLink>
      </div>
      <div>
        <TextLink
          onClick={e => openTermsOfUse(e, tipoTermoUsoEnum.FORNECEDOR)}
          className={styles.link}>
          {t('SUPPLIER_TERMS_OF_USE')}
        </TextLink>
      </div>
      <div>
        <TextLink as={Link} to='/faq?categoria=CLIENTE' className={styles.link}>
          {t('FREQUENTLY_ASKED_QUESTIONS')}
        </TextLink>
      </div>
      <div>
        <TextLink as={Link} to='/cadastro' className={styles.link}>
          {t('I_WANT_TO_BE_A_SUPPLIER')}
        </TextLink>
      </div>
      <div>
        <TextLink
          href='https://www.sebraepr.com.br/artigos/ouvidoria'
          target='_blank'
          rel='noopener noreferrer'
          className={styles.link}>
          {t('OMBUDSMAN')}
        </TextLink>
      </div>
    </div>
  );
}

FooterQuickLinks.propTypes = {
  openTermsOfUse: PropTypes.func.isRequired,
  openPrivacy: PropTypes.func.isRequired
};
